module.exports = __webpack_public_path__ + "fonts/Manrope-700-vietnamese22.d255f9e.woff2";